// Modelos de invitaciones disponibles
export const INVITATION_MODELS = [
  {
    id: 'premium',
    name: 'Invitación Estandar',
    description: 'La opción más completa, incluye Dress Code, Instagram Wall, Sugerencia de canciones y más!',
    image: '/images/modelo_10_es.png',
    url: 'https://model-estandar.vercel.app/',
    buttonClass: 'verde'
  },
  {
    id: 'dresscode',
    name: 'Invitación Dress Code',
    description: 'Las funciones básicas: • RSVP online • Fotos de la pareja • Info regalos',
    image: '/images/modelo_02_es.png',
    url: 'https://andres-deby.vercel.app/',
    buttonClass: 'verde'
  },
  {
    id: 'black',
    name: 'Invitación Premium',
    description: 'Todas las funciones básicas + cuenta regresiva y álbum con hasta 10 fotos de la pareja',
    image: '/images/modelo_04_es.png',
    url: 'https://model-premium.vercel.app/',
    buttonClass: 'verde'
  },
  {
    id: 'classic',
    name: 'Invitación Classic',
    description: 'Las funciones básicas: • RSVP online • Fotos de la pareja • Info regalos',
    image: '/images/modelo_12_es.png',
    url: 'https://pablo-nadia.vercel.app/',
    buttonClass: 'verde'
  },
  {
    id: 'youme',
    name: 'Invitación You & Me',
    description: 'Todas las funciones básicas + cuenta regresiva y álbum con hasta 10 fotos de la pareja',
    image: '/images/modelo_06_es.png',
    url: 'https://www.agendalafecha.com/invitaciones/vintage/',
    buttonClass: 'verde'
  },
  {
    id: 'vintage',
    name: 'Invitación Vintage',
    description: 'La opción más completa, incluye Dress Code, Instagram Wall, Sugerencia de canciones y más!',
    image: '/images/modelo_01_es.png',
    url: 'https://www.agendalafecha.com/invitaciones/black/',
    buttonClass: 'verde'
  }
];
